import React from 'react';
import { Button, Link, Switch } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var ActionBar = function ActionBar(_ref) {
  var id = _ref.id,
    actionBarIsSwitch = _ref.actionBarIsSwitch,
    onClickConnect = _ref.onClickConnect,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    text = _ref.text,
    disabled = _ref.disabled,
    checked = _ref.checked,
    visible = _ref.visible,
    type = _ref.type,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'main' : _ref$variant,
    href = _ref.href;
  if (!visible) return null;
  var handleClick = function handleClick() {
    return onClickConnect === null || onClickConnect === void 0 ? void 0 : onClickConnect({
      title: title,
      cardId: id,
      isOnCardClick: false
    });
  };
  if (type === 'link' && href && text) {
    return /*#__PURE__*/React.createElement(Link, {
      buttonSize: "m",
      buttonVariant: variant,
      extraAttributes: {
        style: {
          zIndex: '5'
        }
      },
      href: href,
      variant: "button",
      "data-t-id": "components-ActionBar"
    }, text);
  }
  if (type === 'switch' || actionBarIsSwitch) {
    return /*#__PURE__*/React.createElement("div", {
      className: cn('switch')
    }, /*#__PURE__*/React.createElement(Switch, {
      checked: checked,
      disabled: disabled,
      name: "connect",
      onChange: handleClick
    }));
  }
  return /*#__PURE__*/React.createElement(Button, {
    disabled: disabled,
    extraAttributes: {
      style: {
        zIndex: '5'
      }
    },
    onClick: handleClick,
    size: "m",
    variant: variant
  }, text);
};